export default {
  params: ['decimalPoints'],
  validate: (value, { decimalPoints }) => {
    let pattern = '^-?[0-9]+([.,][0-9]+)?$'
    if (typeof parseInt(decimalPoints) === 'number') {
      if (decimalPoints < 1) {
        decimalPoints = 1
      }

      pattern = '^-?[0-9]+([.,][0-9]{1,' + parseInt(decimalPoints) + '})?$'
    }

    const regex = new RegExp(pattern)
    if (Array.isArray(value)) {
      return value.every(function (val) { return regex.test(String(val)) })
    }
    return regex.test(String(value))
  }
}
